import React, { useContext } from 'react';
import { Context } from "..";

export default function useDesigner() {
    const context = useContext(Context);
    return context.designer;
}